import React, { useEffect, useState } from 'react';


// import useGlobalState from 'Hooks/useGlobalState';
import { CardHeader, CardContent, Card, Container, Typography, TextField, Grid, Button } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CircularLoader from 'Components/Loaders/CircularLoader';
import { getDevices, getRegistries } from 'Data/api';
import mainStyles from 'Styles/mainStyles';
import { updateDevice } from 'Data/api';
import { isNumeric } from 'validator';

const AdminMoveDevices = () => {
	// const [globalState, dispatch] = useGlobalState();
	const [loading, setLoading] = useState(true);
	const [updatingDevices, setUpdatingDevices] = useState(false)
	const [viewListBuildings, setViewListBuildings] = useState([]);
	const [viewListDevices, setViewListDevices] = useState([]);
	const [deviceFrom, setDeviceFrom] = useState('');
	const [deviceTo, setDeviceTo] = useState('');
	const [filteredDevices, setFilteredDevices] = useState([]);
	const [selectedBuilding, setSelectedBuilding] = useState(null);
	const [movedDevices, setMovedDevices] = useState([]);
	const classes = mainStyles();

	useEffect(() => {
		setLoading(true);
		const fetchData = async () => {
			let buildings = await getRegistries();
			setViewListBuildings(buildings);
			let devices = await getDevices();
			// console.log('AdminMoveDevices - useEffect - devices', devices, buildings);
			setViewListDevices(devices);
			handleSelectDevices('', '');
			setMovedDevices([]);
			setSelectedBuilding(null);
			setLoading(false);
		}
		fetchData();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const padNumber = (num) => {
		return num.toString().padStart(5, '0');
	};

	const handleSelectDevices = (from, to) => {
		console.log('handleSelectDevices', from, to);
		if (to !== '' && from !== '' && isNumeric(to.toString()) && isNumeric(from.toString())) {
			from = parseInt(from, 10);
			to = parseInt(to, 10);
		} else {
			console.log('Invalid input for device numbers:', from, to);
			setFilteredDevices([]);
			return;
		}
		if (to >= from) {
			let filterDevices = []
			for (let i = from; i <= to; i++) {
				let paddedNumber = padNumber(i);
				const deviceName = `skyen${paddedNumber}`;
				// console.log('Looking for device:', deviceName);
				
				const device = viewListDevices.find(d => d.uuname === deviceName);
				if (device) {
					filterDevices = [...filterDevices, device];
				}
			}
			setFilteredDevices(filterDevices);
			setMovedDevices([]);
		} else {
			setDeviceFrom(from);
			setDeviceTo(to);
			setFilteredDevices([]);
		}
	};

	const handleMoveDevices = async () => {
		if (filteredDevices.length > 0 && selectedBuilding) {
			setUpdatingDevices(true);
			let devicesToMove = filteredDevices;
			let myFiltered = filteredDevices
			let movedDevicesDone = movedDevices;
			await devicesToMove.reduce(async (promise, device) => {
				// This line will wait for the last async function to finish.
				// The first iteration uses an already resolved Promise
				// so, it will immediately continue.
				await promise;

				device.registry = selectedBuilding; // Update the registry of the device
				let myPromise = await updateDevice(device);
				
				console.log('Moving device:', device.uuname, 'to building:', selectedBuilding.name);
				
				// move device from filteredDevices to movedDevices
				movedDevicesDone.push(device);
				setMovedDevices(movedDevicesDone);

				myFiltered = myFiltered.filter(d => d.uuname !== device.uuname);
				setFilteredDevices(myFiltered);
				
				return myPromise
			}, Promise.resolve())
			setMovedDevices(movedDevicesDone);
			handleSelectDevices('', '');
			setUpdatingDevices(false);
		} else {
			alert('Ingen enheder valgt eller bygning ikke valgt.');
		}
	};

	return (!loading ?
		<>
		<Container maxWidth="lg" style={{ padding: '20px', marginBottom: '100px' }}>
			<Card>
				<CardHeader title="Flyt enheder" />
				<CardContent>
					<Grid container spacing={2} style={{ marginTop: '0px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Typography variant="body1" color="textSecondary">
								Vælg den bygning enhederne skal flyttes til.
							</Typography>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ marginTop: '0px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>

							<Autocomplete
								disablePortal
								id="combo-box-demo"
								options={viewListBuildings}
								getOptionLabel={(option) => option.name + '(' + option.org.name + ')'}
								renderInput={(params) => <TextField {...params} label={'Vælg bygning'} />}
								onChange={(event, value) => {
									if (value) {
										setSelectedBuilding(value);
										console.log('Selected building:', selectedBuilding, value);
										// handleMoveDevices(deviceFrom, deviceTo);
									}
								}}
								style={{ width: '100%' }}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ marginTop: '20px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Typography variant="body1" color="textSecondary">
								Vælg enheder der skal flyttes:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<TextField
								style={{ width: '100%' }}
								autoFocus
								id="searchfrom"
								label="Enhedsnummer fra"
								variant="outlined"
								onChange={(event) => {
									const searchValue = event.target.value;
									setDeviceFrom(searchValue);
									console.log('Search:', searchValue, deviceTo);
									handleSelectDevices(searchValue, deviceTo);
								}}
								value={deviceFrom}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<TextField
								style={{ width: '100%' }}
								id="searchto"
								label="Enhedsnummer til"
								variant="outlined"
								onChange={(event) => {
									const searchValue = event.target.value;
									setDeviceTo(searchValue);
									handleSelectDevices(deviceFrom, searchValue);
								}}
								value={deviceTo}	
							/>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ marginTop: '20px' }}>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<Typography variant="body1" color="textSecondary">
								Enheder der skal flyttes:
							</Typography>
							{filteredDevices.length > 0 ? (
								filteredDevices.map((device, index) => (
									<Grid item xs={12} sm={12} md={12} lg={12} key={index}>
										<Typography variant="body1">
											{device.uuname} - {device.name} ({device.registry.name})
										</Typography>
									</Grid>
								))
							) : (
								<Grid item xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" color="textSecondary">
										Ingen enheder valgt.
									</Typography>
								</Grid>
							)}
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<Typography variant="body1" color="textSecondary">
								Enheder der er blevet flyttet:
							</Typography>
							{movedDevices.length > 0 ? (
								movedDevices.map((device, index) => (
									<Grid item xs={12} sm={12} md={12} lg={12} key={index}>
										<Typography variant="body1">
											{device.uuname} - {device.name}
										</Typography>
									</Grid>
								))
							) : (
								<Grid item xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" color="textSecondary">
										Ingen enheder flyttet endnu.
									</Typography>
								</Grid>
							)}
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ marginTop: '0px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							{!updatingDevices ? <Button onClick={handleMoveDevices} variant="contained" className={classes.greenButton}>Flyt enheder</Button> : <CircularLoader />}
							
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</Container>

		</>
		:
		<CircularLoader />
	);
};

export default AdminMoveDevices;